import LogoText from './LogoText';

export default LogoText;
